import { t } from "i18next";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
const ErrorComponent = ({ type, data }) => {
    if (type === 1) {
        return (
            <div class="body_container">

                <section class="app_main_wrapper d-flex flex-column light_gray_bg">
                    <div class="bottom_bg_section">
                        <div class="bottom_bg_section_container">
                            <img src="assets/images/assets_bg.jpg" alt="" />
                        </div>
                    </div>
                    <div class="center_section">
                        <div class="sec_top mt-160">
                            <div class="pse_md">
                                <div class="text-center mb-5">
                                    <div class="mb-5">
                                        <picture>
                                            <img src={process.env.PUBLIC_URL + '/assets/images/error_red.svg'} width="{100px}" alt="" title="" />
                                        </picture>
                                    </div>
                                    <div>
                                        <h2 class="mb-2 page_title_v1 primary_color">{t("errorMsg")}</h2>
                                        <p class="mb-3 primary_14 dark_gray_color">{t("somethingwentwrong")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        );
    }

    if (type === 2) {
        return (
            <div class="body_container">

                <section class="app_main_wrapper d-flex flex-column light_gray_bg">
                    <div class="bottom_bg_section">
                        <div class="bottom_bg_section_container">
                            <img src="assets/images/assets_bg.jpg" alt="" />
                        </div>
                    </div>
                    <div class="center_section">
                        <div class="sec_top mt-160">
                            <div class="pse_md">
                                <div class="text-center mb-5">
                                    <div class="mb-5">
                                        <picture>
                                            <img src={process.env.PUBLIC_URL + '/assets/images/error_red.svg'} width="{100px}" alt="" title="" />
                                        </picture>
                                    </div>
                                    <div>
                                        <h2 class="mb-2 page_title_v1 primary_color">{t("errorMsg")}</h2>
                                        <p class="mb-3 primary_14 dark_gray_color">{t("somethingwentwrong")}</p>
                                        <Link className="hyperlink hyperlink_sm" to="/#">Click Link to Go Home</Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        );
    }
};
export default ErrorComponent;
